import * as React from 'react';
import { cn } from '../../lib/cn.js';

export interface CardProps extends React.HTMLAttributes<HTMLElement> {
  as?: 'section' | 'div' | 'article';
  padding?: 'none' | 'md' | 'lg';
}

export function Card({ as: Tag = 'section', padding = 'md', className, ...props }: CardProps) {
  return (
    <Tag
      className={cn(
        'min-w-0 rounded-card border border-border-subtle bg-surface-default shadow-card',
        padding === 'md' && 'p-5',
        padding === 'lg' && 'p-6',
        className,
      )}
      {...props}
    />
  );
}

export interface CardHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  /** Heading level for document outline. */
  level?: 2 | 3;
  className?: string;
  id?: string;
}

export function CardHeader({ title, description, actions, level = 2, className, id }: CardHeaderProps) {
  const H = level === 2 ? 'h2' : 'h3';
  return (
    <div className={cn('mb-4 flex flex-wrap items-start justify-between gap-3', className)}>
      <div className="grid min-w-0 gap-0.5">
        <H id={id} className="text-card-title font-semibold text-text-primary">
          {title}
        </H>
        {description ? <div className="text-body text-text-secondary">{description}</div> : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export function CardFooter({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-border-subtle pt-4', className)} {...props} />;
}
